<div class="accommodations__content">
  <lx-message type="alert" color="blue" data-qa="accommodation-details_alert" *ngIf="moreAccommodationsDisclaimerShown">
    <ng-container i18n> You're seeing our standard options. Your advisor can help you with other room and meal upgrades! </ng-container>
  </lx-message>

  <lx-option-card
    *ngFor="let accommodation of accommodations"
    [type]="'radio'"
    [title]="accommodation?.name"
    [image]="accommodation?.galleryUrls?.[0] || ACCOMMODATIONS_FALLBACK_IMAGE"
    [fallbackImage]="ACCOMMODATIONS_FALLBACK_IMAGE"
    [option]="accommodation?.code"
    [selectedOption]="selectedAccommodation?.code"
    [attr.data-qa]="'accommodations_header'"
    (selectedOptionChanged)="setSelectedAccommodation(accommodation)"
  >
    <div class="accommodations__description">
      <div>
        <div class="accommodations__description__info">
          <lx-accommodation-options [accommodation]="accommodation"></lx-accommodation-options>
        </div>
        <div class="accommodations__description__see-more-button">
          <lx-button
            i18n-text
            text="See more"
            [buttonStyle]="'plain-text'"
            [isUnderlined]="true"
            (buttonClick)="openAccommodationDetailsSidePanel(accommodation)"
            [lxGAClickEvent]="seeMoreEventName"
          >
          </lx-button>
        </div>
      </div>
      <div class="accommodations__description__price-container" *ngIf="accommodation?.multiCurrencyPrice">
        <div class="accommodations__description__price-info" i18n>from (per week)</div>
        <div class="accommodations__description__price" data-qa="accommodations_price">
          {{ accommodation?.multiCurrencyPrice | lxPrice : { currency: selectedCurrency$ | async } }}
        </div>
      </div>
    </div>
  </lx-option-card>
  <lx-option-card
    *ngIf="accommodationOptional"
    title="I don't need accommodation"
    i18n-title
    [withImage]="false"
    [type]="'radio'"
    [selectedOption]="selectedAccommodation?.code"
    (selectedOptionChanged)="setSelectedAccommodation()"
    [attr.data-qa]="'accommodations_noAccommodation_button'"
  ></lx-option-card>
</div>

<lx-side-panel-gallery
  [visible]="accommodationDetailsDialogVisible"
  (hiddenPanel)="hideAccommodationDetailsDialog()"
  data-qa="accommodation_details_sidePanel"
  [fallbackImage]="ACCOMMODATIONS_FALLBACK_IMAGE"
  [images]="galleryUrls"
>
  <lx-accommodation-details [accommodation]="detailsAccommodation"></lx-accommodation-details>
</lx-side-panel-gallery>
